import React, { useCallback, useContext } from 'react';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { pushGlobalConfirmationModal } from '../../Modals/redux/actionCreators';
import { unpublishDeviation } from '../../redux/deviations/actionCreators';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
export function useUnpublishFlow({ deviation, onClose, onConfirmOverride, onCompleteAction, isPlural = false }) {
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const dispatchPushGlobalConfirmationModal = useAction(pushGlobalConfirmationModal);
    const dispatchUnpublishDeviation = useAction(unpublishDeviation);
    return useCallback(()=>{
        dispatchPushGlobalConfirmationModal({
            // Why not rely on the `count` param of translations to handle this pluralization? The props for confirmation modals
            // as-is do not support passing it through. Rather than complicate that API further, I've opted to rely on the already
            // required isPlural param.
            titleTransKey: isPlural ? 'unpublish.confirmModal.title.plural' : 'unpublish.confirmModal.title',
            isFullscreen: false,
            icon: !isMobile && /*#__PURE__*/ React.createElement("img", {
                alt: "",
                src: "https://st.deviantart.net/eclipse/illustrations/il6-1-3_140px.png"
            }),
            variant: 'horizontal',
            textComponent: ()=>t(isPlural ? 'unpublish.confirmModal.text.plural' : 'unpublish.confirmModal.text', {
                    postProcess: 'reactPostprocessor',
                    learnMoreLink: /*#__PURE__*/ React.createElement("a", {
                        className: "text-link-level-2-primary underline",
                        href: t('unpublish.confirmModal.text.learnMoreLink.url')
                    }, t('unpublish.confirmModal.text.learnMoreLink.text'))
                }),
            confirmBtnLabelTransKey: 'unpublish.confirmModal.confirmButton.label',
            cancelBtnLabelTransKey: 'unpublish.confirmModal.cancelButton.label',
            onConfirm: ()=>onConfirmOverride ? onConfirmOverride() : dispatchUnpublishDeviation({
                    deviation,
                    onCompleteAction
                }),
            onRequestClose: onClose
        });
    }, [
        t,
        deviation,
        dispatchPushGlobalConfirmationModal,
        dispatchUnpublishDeviation,
        onCompleteAction,
        onClose,
        onConfirmOverride,
        isPlural,
        isMobile
    ]);
}

//# sourceMappingURL=useUnpublishFlow.js.map